import * as dictionary from "../../dict/static.json";

const config: any = dictionary['config'];

export class AppConfig {
	public static backendPrefix: string = config.backendPrefix;
}
